export default __webpack_public_path__ + "static/logo-e5603b6f631406fae75ddcef6291e002.webp";